import { useSelector } from "react-redux";
import { State } from "redux/store";
import classNames from "classnames";
import { useParams } from "react-router";
import { getDataset, getEntityTypeFilter } from "redux/SingleDataset/selectors";
import { AMP_DATASET_EXPLORATION_PROPERTY__ENTITY_TYPE } from "helpers/constants/amplitudeProperties";
import {
  AMP_DATASET_EXPLORATION_EVENT__TEXTUAL_SEARCH__APPLIED,
  AMP_DATASET_EXPLORATION_EVENT__TEXTUAL_SEARCH__REMOVED,
} from "helpers/constants/amplitudeEvents";
import { amplitudeTrack } from "helpers/utility/amplitude";
import { SearchContainer as SearchContainerV2 } from "./SearchContainer/SearchContainer";

import { FilterOption } from "types";

import styles from "./style.module.scss";
import { EntityTypeToggle } from "./EntityTypeToggle/EntityTypeToggle";
import { ClusterModeDropdown } from "./ClusterModeDropdown/ClusterModeDropdown";
import { SaveViewButton } from "./SaveViewButton/SaveViewButton";
import { RightPanelToggleButton } from "./RightPanelToggleButton/RightPanelToggleButton";
import { useClearSavedSearchParam } from "../../../../../hooks/useClearSavedSearchParam";
import { useUserConfig } from "../../../../../hooks/useUserConfig";
import useEntityTypeFromQuery from "../../../../../hooks/useEntityTypeFromQuery";

const DataPageFilters = () => {
  const { isLoading: isUserConfigLoading } = useUserConfig();
  const entityTypeFromQueryParam = useEntityTypeFromQuery();
  const entityTypeFilter = useSelector((state: State) =>
    getEntityTypeFilter(state, entityTypeFromQueryParam),
  );
  const dataset = useSelector(getDataset);
  const { datasetId, clusterId } = useParams();

  const filterSectionClassnames = classNames(styles.filterSection);

  useClearSavedSearchParam();

  const logSearchText_Amplitude = (
    entities: FilterOption[],
    context: "added" | "removed",
  ) => {
    const event =
      context === "added"
        ? AMP_DATASET_EXPLORATION_EVENT__TEXTUAL_SEARCH__APPLIED
        : AMP_DATASET_EXPLORATION_EVENT__TEXTUAL_SEARCH__REMOVED;
    const selectedEntities = entities
      .filter((entity) => entity.selected)
      .map((entity) => entity.text);

    let value;
    if (selectedEntities.length > 0) {
      value = selectedEntities.join(",");
    } else {
      value = "Images";
    }

    amplitudeTrack(event, {
      [AMP_DATASET_EXPLORATION_PROPERTY__ENTITY_TYPE]: value,
    });
  };

  const renderFilterSection = () => {
    return (
      <div className={styles.searchBar}>
        {!isUserConfigLoading && dataset && (
          <div className={styles.searchRow}>
            <EntityTypeToggle />
            <SearchContainerV2
              className={styles.searchContainer}
              datasetId={datasetId!}
              logSearchAddition={() => {
                logSearchText_Amplitude(entityTypeFilter, "added");
              }}
              logSearchRemoval={() => {
                logSearchText_Amplitude(entityTypeFilter, "removed");
              }}
            />
            <div className={styles.rightEnd}>
              <SaveViewButton className={styles.saveViewButton} iconOnly />
              <ClusterModeDropdown
                datasetId={datasetId!}
                disabled={Boolean(clusterId)}
              />
              <RightPanelToggleButton className={styles.rightPanelToggle} />
            </div>
          </div>
        )}
      </div>
    );
  };

  return <div className={filterSectionClassnames}>{renderFilterSection()}</div>;
};

export default DataPageFilters;
